var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevroninline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CCDDC7",
  stroke: "#30715D",
  d: "M7.78074 8.634C7.35992 9.122 6.64008 9.122 6.21926 8.634L1.28424 2.91117C0.655386 2.18193 1.13822 1 2.06498 1L11.935 1C12.8618 1 13.3446 2.18193 12.7158 2.91117L7.78074 8.634Z"
})));
export default SvgChevroninline;